import { render, staticRenderFns } from "./Inspiration.vue?vue&type=template&id=fa79e2f0&scoped=true"
import script from "./Inspiration.vue?vue&type=script&lang=js"
export * from "./Inspiration.vue?vue&type=script&lang=js"
import style0 from "./Inspiration.vue?vue&type=style&index=0&id=fa79e2f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa79e2f0",
  null
  
)

export default component.exports